import { fromJS } from 'immutable';

import {
  REQUEST_FUNDING_FAQS,
  REQUEST_FUNDING_FAQS_SUCCESS,
  REQUEST_FUNDING_FAQS_FAILURE,
} from './types';

const initialState = fromJS({
  fundingFaqs: {
    faqs: false,
    network: { loading: false, error: false },
  },
});

export function requestFundingFaqs() {
  return { type: REQUEST_FUNDING_FAQS };
}

export function requestFundingFaqsSuccess(response) {
  return {
    type: REQUEST_FUNDING_FAQS_SUCCESS,
    response,
  };
}

export function requestFundingFaqsFailure(error) {
  return {
    type: REQUEST_FUNDING_FAQS_FAILURE,
    error,
  };
}

export default function faqsReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_FUNDING_FAQS:
      return state.setIn(['fundingFaqs', 'network', 'loading'], true);
    case REQUEST_FUNDING_FAQS_SUCCESS:
      return state.withMutations((s) =>
        s
          .setIn(['fundingFaqs', 'network', 'loading'], false)
          .setIn(['fundingFaqs', 'network', 'error'], false)
          .setIn(['fundingFaqs', 'faqs'], fromJS(action.response)),
      );
    case REQUEST_FUNDING_FAQS_FAILURE:
      return state.withMutations((s) =>
        s
          .setIn(['fundingFaqs', 'network', 'loading'], false)
          .setIn(['fundingFaqs', 'network', 'error'], action.error),
      );
    default:
      return state;
  }
}
